<template>
  <v-card :style="backOpacity">
    <v-card-title>認証情報の設定 AuthconfForm.vue</v-card-title>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="12">
            <v-text-field
              label="ラベル名"
              v-model="returnData.label"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <set-Cols
              :value="returnData.cols"
              v-on:set="$set(returnData, 'cols', $event)"
            ></set-Cols>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="5">
            <v-radio-group label="表示形式" v-model="returnData.init" column>
              <v-radio
                label="ユーザ情報の設定(リスト形式)"
                value="default"
              ></v-radio>
              <v-radio
                label="ユーザ名(既存値優先・入力可)"
                value="name"
              ></v-radio>
              <v-radio
                label="ユーザ名(自動・入力不可・上書き)"
                value="auto"
              ></v-radio>
              <v-radio
                label="ユーザ名(自動入力・上書き無し)"
                value="autoName"
              ></v-radio>
              <v-radio label="記入ユーザの自動追加" value="autoAdd"></v-radio>
              <v-radio
                label="カスタム属性(自動・入力不可)"
                value="attribute"
              ></v-radio>
              <v-radio
                label="カスタム属性(自動・入力不可)非表示"
                value="attributeNoView"
              ></v-radio>
              <v-radio
                label="ユーザ設定ページの追加フォーム取得(表示)"
                value="userInfoView"
              ></v-radio
              >*(,)区切りの場合はセレクトボックスで選択
              <v-radio
                label="ユーザ設定ページの追加フォーム取得(非表示)"
                value="userInfo"
              ></v-radio>
              <v-radio label="パスワード入力" value="password"></v-radio>
              <v-radio label="uuIDを表示" value="uuID"></v-radio>
              <v-radio label="メールアドレスを表示" value="email"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col
            cols="2"
            v-if="
              returnData.init == 'userInfo' || returnData.init == 'userInfoView'
            "
          >
            <search-Page
              label="表示対象フォームID"
              v-model="rules[0]"
            ></search-Page>
            <!--
            <v-text-field
              label="表示対象フォームID"
              v-model="rules[0]"
              :rules="[]"
            ></v-text-field
          >          -->
          </v-col>
          <v-col cols="3" v-if="returnData.init == 'userInfo'">
            <v-checkbox
              v-model="rules[1]"
              label="上書き無し(既存値優先)"
              value="true"
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-row v-if="returnData.init == 'uuID' || returnData.init == 'email'">
          <v-col cols="2">
            <v-checkbox
              v-model="rules[2]"
              label="非表示"
              value="true"
            ></v-checkbox>
          </v-col>
          <v-col cols="2">
            <v-checkbox
              v-model="rules[3]"
              label="入力不可"
              value="true"
            ></v-checkbox>
          </v-col>
          <v-col cols="2">
            <v-checkbox
              v-model="rules[4]"
              label="上書き無し"
              value="true"
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" v-if="returnData.init == 'password'">
            <v-select
              :items="passwordRule"
              item-text="text"
              item-value="value"
              v-model="rules[0]"
              label="パスワードルール"
              :rules="[]"
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="8"
            v-if="
              returnData.init == 'userInfo' || returnData.init == 'userInfoView'
            "
          >
            <v-text-field
              label="選択肢から除外する値 (,区切り)"
              v-model="returnData.value"
              :rules="[]"
            ></v-text-field
          ></v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        v-show="showButton"
        color="success"
        @click.once="submit"
        v-on:mouseover="backOpacity = 'opacity: 0.1'"
        v-on:mouseleave="backOpacity = 'opacity: 1'"
        fixed
        bottom
        right
        x-large
        class="mr-10 mb-8"
        >OK</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import setCols from "./common/setCols.vue";
import searchPage from "./common/searchPage.vue";
export default {
  components: {
    setCols,
    searchPage,
  },
  props: {
    label: String,
    init: String,
    type: Number,
    position: Number,
    cols: String,
    rule: String,
    value: String,
  },
  data() {
    return {
      returnData: {
        label: this.label,
        init: this.init,
        type: this.type,
        position: this.position,
        cols: this.cols,
        rule: this.rule,
        value: this.value,
      },
      backOpacity: "opacity: 1",
      showButton: false,
      passwordRule: [
        {
          text: "アルファベット大・小文字数字を含む8文字以上",
          value: "ruleSet1",
        },
        { text: "アルファベット大・小文字含む8文字以上", value: "ruleSet2" },
        {
          text: "英/大文字・英/小文字・数字・記号の3種類を含む8文字以上",
          value: "ruleSet3",
        },
      ],
      rules: [0, 0],
      varidation: {
        cols: (value) => {
          return /^([0-9]|1[0-2]|auto)$/.test(value) || "0~12,autoのみ";
        },
      },
    };
  },
  mounted() {
    setTimeout(() => {
      this.showButton = true;
    }, 500);

    if (typeof this.rule != "undefined" && this.rule != null) {
      this.rules = this.rule.split(",");
    }
  },
  methods: {
    submit() {
      this.returnData.rule = this.rules.join(",");
      this.$emit("clickSubmit", this.returnData);
    },
  },
};
</script>
